"use strict";

define('uikit/extra/key.codes',{
  BACKSPACE_KEY: 8,
  TAB_KEY: 9,
  ENTER_KEY: 13,
  SPACE_KEY: 32,
  LEFTARROW_KEY: 37,
  UPARROW_KEY: 38,
  RIGHTARROW_KEY: 39,
  DOWNARROW_KEY: 40,
  DELETE_KEY: 46,
  ESCAPE_KEY: 27,
  SEMICOLON_KEY: 186,
  COMMA_KEY: 188
});

